import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import infoIco from 'assets/images/i-circle.svg';
import eye from 'assets/images/eye.png';
import hidden from 'assets/images/hidden.png';
import { Button, CloseButton, Carousel, Modal, Tab, Tabs } from 'react-bootstrap';
import logo from 'assets/images/eb-logo.svg';
import banner1 from 'assets/images/banner1.jpeg';
import banner2 from 'assets/images/banner2.jpeg';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import api from 'api/client';
import LoginService from 'pages/login/services/login.service';
import Newsignin from './newsignin.service';
import { toast, ToastContainer } from 'react-toastify';
import { userStore } from '../../store/UserStore';
import DashboardHttp from '../profile/services/profile.service';
import OtpWithTimer from 'shared/common/otpWithTimer/otpWithTimer';
import {
  ACK_FAIL,
  ACK_SUCCESS,
  OTP_SENT_TO_EMAIL,
  OTP_SENT_TO_MOBILE,
  OTP_SENT_TO_REG_MESSAGE,
  OTP_VERIFY_FAILURE,
  OTP_VERIFY_SUCCESS,
} from 'constants/messages.constant';
import OtpPopup from 'shared/common/otp-modal/otpModal';
import PasswordUpdate from 'pages/login/passwordUpdate';
import {
  getStoredUtm,
  markLoginCustomerIdPending,
  netcoreDate,
  netcoreTrack,
  normalizeMobile,
} from 'utils/netcoreTracking';
import CustomerHttp from 'pages/customer/services/customer.service';
import format from 'string-template';

interface PropsType { }

const Login: React.FC<PropsType> = () => {
  const indFormRef = useRef(null);
  const entFormRef = useRef(null);
  const [otpValue, setOtpValue] = useState<string>('');
  const [session, setSession] = useState(null);
  const [signInSession, setSignInSession] = useState(null);
  const [errorModal, setErrorModal] = useState<any>({});
  const [isOtpLogin, setIsOtpLogin] = useState<boolean>(false);
  const [isOtpSent, setIsOtpSent] = useState<boolean>(false);
  const [isLoginError, setIsLoginError] = useState(false);
  const [accounts, setAccounts] = useState<any>([]);
  const [enableResend, setEnableResend] = useState(false);
  const [mobile, setMobile] = useState('');
  const [values, setVal] = useState({});
  const history = useHistory();
  const [modalShow, setModalShow] = useState<boolean>(false);
  const [countryCode, setCountryCode] = useState('+91');
  const [isLoading, setLoading] = useState<boolean>(false);
  const [isShowPwd, setShowPwd] = useState<boolean>(false);
  const { setLoginData } = userStore();
  const [pan, setPan] = useState('');
  const [key, setKey] = useState(sessionStorage.getItem('category') || 'b2c');
  const [email, setEmail] = useState('');
  const [verifyEmail, setVerifyEmail] = useState(false);
  const [token, setToken] = useState(null);

  const [passwordUpdateObj, setPasswordUpdateObj] = useState({
    display: false,
    cognitoUser: null,
    userAttr: null,
  });

  const [setCustomerId, setCustomer, setCustomers, user, setUser] = userStore(
    (state: any) => [
      state.setCustomerId,
      state.setCustomer,
      state.setCustomers,
      state.user,
      state.setUser,
    ]
  );
  const [otpData, setOtpData] = useState<OtpData>({
    value: '',
    ackMessage: '',
    ackMessageType: 'success',
  });
  const [showTerms, setShowTerms] = useState(false);

  useEffect(() => {
    document.title = 'SignIn/SignUp - eBullion';
  }, []);

  useEffect(() => {
    sessionStorage.setItem('category', key);
  }, [key]);

  useEffect(() => {
    if (otpData.value?.length === 6) {
      verifyEmail ? onEmailOtpSuccess() : onSuccess();
    }
  }, [otpData.value]);

  const resetOtpData = () => {
    setOtpData({
      value: '',
      ackMessage: '',
      ackMessageType: 'success',
    });
  };

  const location = useLocation();
  let ID = new URLSearchParams(location.search).get('customerId');

  const getProfile = async (customerId: any) => {
    try {
      const userData: any = await DashboardHttp.getProfile(
        customerId,
        user?.userId
      );
      if (userData.status === 200 && userData.data.data) {
        setCustomer(userData.data.data.customer);
        history.push(new URLSearchParams(location.search).get('returnUrl'));
      }
    } catch (e: any) {
      //setLoading(false);
    }
  };

  const getAccounts = async (customerId: any, userId: any) => {
    try {
      setLoading(true);
      const userData: any = await DashboardHttp.getProfile(customerId, userId);
      if (userData.status === 200 && userData.data.data) {
        setCustomerId(customerId);
        setCustomer(userData.data.data.customer);
        setAccounts(userData.data.data.customer.accounts);
      }
    } catch (e: any) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const getUserProfile = async () => {
    setLoading(true);
    try {
      const res: any = await CustomerHttp.getUserProfile(user?.userId);
      if (res.status === 200 && res.data.data) {
        setCustomers(res.data.data.customers);
        setUser(res.data.data);
        getAccounts(
          res.data.data.customers[0].customerId,
          res.data.data.userId
        );
      }
    } catch (e: any) {
      console.log(e.message);
      setLoading(false);
    }
  };

  // Netcore: existing user signed in (not fired for a brand-new signup).
  const trackLogin = (method: string, mobileNo: string) => {
    netcoreTrack('user_login', { login_method: method }, mobileNo, {
      LAST_LOGIN_AT: netcoreDate(new Date()),
    });
    markLoginCustomerIdPending();
  };

  // Netcore: new user verified the mobile OTP (UC1 Welcome Journey trigger).
  const trackRegistration = (mobileNo: string) => {
    const utm = getStoredUtm();
    netcoreTrack(
      'completed_registration',
      {
        mobile: normalizeMobile(mobileNo),
        registration_method: 'otp',
        ...utm,
      },
      mobileNo,
      {
        SIGNUP_DATE: netcoreDate(new Date()),
        UTM_SOURCE: utm.utm_source,
        UTM_MEDIUM: utm.utm_medium,
        UTM_CAMPAIGN: utm.utm_campaign,
      }
    );
  };

  const signIn = async (val, setFieldTouched, setFieldError, setFieldValue) => {
    setLoading(true);
    setMobile(countryCode + val.username);
    setVal(val);

    if (!isOtpLogin) {
      if (!isOtpSent) {
        setFieldTouched('username', true);
        if (val.username && val.username.length === 10) {
          sendMobileOtp(val, setFieldValue);
        } else {
          setFieldError('username', 'Invalid mobile number');
        }
      } else {
        verifyMobileOtp(val);
      }
    } else {
      try {
        const res: any = await LoginService.login(
          countryCode + val.username,
          val.password
        );

        if (res) {
          if (res.changeRequired) {
            setPasswordUpdateObj({
              ...passwordUpdateObj,
              display: true,
              cognitoUser: res.user,
              userAttr: res.userAtr,
            });
          } else {
            setLoginData({
              customer: {},
              customerId: '',
              selectedAccount: {},
              user: {},
              tokens: {
                accessToken: res.getAccessToken(),
                idToken: res.getIdToken(),
                refreshToken: res.getRefreshToken(),
              },
              userData: res.getIdToken().decodePayload(),
            });
            api.setAuthAccess(res.accessToken.jwtToken);
            api.setAuthRefresh(res.refreshToken.token);
            api.setToken(res.idToken.jwtToken);

            trackLogin('password', countryCode + val.username);
            if (ID) {
              setCustomerId(ID);
              getProfile(ID);
            }
            history.push('/customers');
          }
        }

        setLoading(false);
      } catch (err: any) {
        let error = JSON.parse(JSON.stringify(err));
        handleAwsErrors(error.code);
        setLoading(false);
      }
    }
  };
  const handlePasswordUpdateClose = () => {
    setPasswordUpdateObj({
      ...passwordUpdateObj,
      display: false,
      cognitoUser: null,
      userAttr: null,
    });
  };

  const entSignIn = async (val) => {
    setLoading(true);
    setVal(val);
    try {
      const res: any = await LoginService.entLogin(val.username, val.password);
      if (res) {
        if (!res.idToken.payload.email_verified) {
          setEmail(res.idToken.payload.email);
          setModalShow(true);
          setVerifyEmail(true);
          setToken(res);
        } else {
          setLoginData({
            customer: {},
            customerId: '',
            selectedAccount: {},
            user: {},
            tokens: {
              accessToken: res.getAccessToken(),
              idToken: res.getIdToken(),
              refreshToken: res.getRefreshToken(),
            },
            userData: res.getIdToken().decodePayload(),
          });
          api.setAuthAccess(res.accessToken.jwtToken);
          api.setAuthRefresh(res.refreshToken.token);
          api.setToken(res.idToken.jwtToken);
          if (ID) {
            setCustomerId(ID);
            getProfile(ID);
          }
          history.push('/accounts');
        }
      }
      setLoading(false);
    } catch (err: any) {
      let error = JSON.parse(JSON.stringify(err));
      handleAwsErrors(error.code);
      setLoading(false);
    }
  };
  const handleAwsErrors = (errorCode) => {
    if (errorCode.includes('UserNotConfirmedException')) {
      setIsLoginError(true);
      setErrorModal({
        ...errorModal,
        title: 'Account Verification Pending',
        message:
          'Your account is not verified yet. An OTP will be sent to your registered mobile number.',
        type: 'warn',
      });
      return toast.error('Please verify your mobile number');
    }
    if (errorCode.includes('userNotFound')) {
      return toast.error('User with given phone number does not exist');
    }
    if (errorCode.includes('NewPasswordRequiredException')) {
      return toast.error(
        'You need to login with temporary password and set new password first.',
        {
          autoClose: false,
        }
      );
    }
    switch (errorCode) {
      case 'UserNotConfirmedException':
        setIsLoginError(true);
        setErrorModal({
          ...errorModal,
          title: 'Account Verification Pending',
          message:
            'Your account is not verified yet. An OTP will be sent to your registered mobile number.',
          type: 'warn',
        });
        toast.error('Please verify your mobile number');
        break;
      case 'ExpiredCodeException':
        toast.error('Verification code expired');
        break;
      case 'NotAuthorizedException':
        isOtpLogin
          ? toast.error('Invalid Username or Password')
          : toast.error('OTP entered is incorrect');
        break;
      case 'CodeMismatchException':
        toast.error('Please enter valid verification code');
        break;

      default:
        toast.error('Somthing went wrong');
        break;
    }
  };

  const sendOtp = async () => {
    setLoading(true);
    try {
      const res: any =
        key === 'b2c'
          ? await LoginService.sendOTP(mobile)
          : await LoginService.entSendOTP(pan);
      setLoading(false);
      if (res) {
        setModalShow(true);
        setIsLoginError(false);
      }
    } catch (err: any) {
      let error = JSON.parse(JSON.stringify(err));
      handleAwsErrors(error.code);
      setLoading(false);
      toast.error('Something went wrong, Please try again later');
    }
  };
  const sendMobileOtp = async (values: any, setFieldValue) => {
    if (values.username) {
      setLoading(true);
      setMobile(`+91${values.username}`);
      const data = {
        mobile: `+91${values.username}`,
        partnerId: '1',
      };
      try {
        const res: any = await Newsignin.sendNewOtp(data, token);
        setLoading(false);
        if (res) {
          setFieldValue('isOtpSent', true);
          setSignInSession(res?.data?.data);
          setSession(res);
          setIsOtpSent(true);
          setShowTerms(res?.data?.data?.signUp === true); // Show terms if signup is true
        }
      } catch (error: any) {
        setFieldValue('isOtpSent', false);
        setLoading(false);
        if (error?.response?.status === 429) {
          toast.error(error.response.data.error);
        }
      }
    }
  };

  const verifyMobileOtp = async (values: any) => {
    if (values.username && values.otp) {
      setLoading(true);
      try {
        const res: any = await LoginService.verifyLoginOtp(session, values.otp);

        setLoading(false);
        if (res.signInUserSession) {
          api.setAuthAccess(res.signInUserSession.accessToken.jwtToken);
          api.setAuthRefresh(res.signInUserSession.refreshToken.token);
          api.setToken(res.signInUserSession.idToken.jwtToken);
          if (signInSession?.signUp === true) {
            trackRegistration(mobile || `+91${values.username}`);
          } else {
            trackLogin('otp', mobile || `+91${values.username}`);
          }
          history.push('/customers');
        } else {
          toast.error('OTP entered is incorrect');
        }
      } catch (err) {
        let error = JSON.parse(JSON.stringify(err));
        handleAwsErrors(error.code);
        setLoading(false);
      }
    }
  };

  const newVerifyOtp = async (values: any) => {
    try {
      const data = {
        ...signInSession,
        mobile: `+91${values.username}`,
        otp: values.otp,
        partnerId: '1',
      };

      const res = await Newsignin.verifyNewOtp(data);
      if (res.data.data.tokens) {
        api.setAuthAccess(res?.data?.data?.tokens?.AccessToken);
        api.setAuthRefresh(res.data.data.tokens.RefreshToken);
        api.setToken(res.data.data.tokens.IdToken);
        if (signInSession?.signUp === true) {
          trackRegistration(data.mobile);
        } else {
          trackLogin('otp', data.mobile);
        }
        history.push('/customers');
      } else {
        toast.error(res?.data?.errors[0].title);
      }
    } catch (err: any) {
      console.log(err);
      toast.error(err?.data?.errors[0].title);
    }
  };

  const sendOtpThroughMail = async () => {

    setLoading(true);
    try {
      const res: any = await LoginService.sendOTPToEmail(
        token.idToken.jwtToken,
        token.accessToken.jwtToken
      );

      setLoading(false);

      if (res) {
        resetOtpData();
        setModalShow(true);
      }
    } catch (err: any) {
      setLoading(false);

      if (err) {
        toast.error(err.data.errors[0].title);
      } else {
        toast.error('Something went wrong');
      }
    }
  };

  const onSuccess = async () => {
    setLoading(true);
    try {
      console.log('hereotp');
      const res: any =
        key === 'b2c'
          ? await LoginService.verifyOTP(mobile, otpData?.value)
          : await LoginService.verifyEntOTP(pan, otpData?.value);
      // const res: any = await LoginService.verifyOTP(mobile, otpData?.value);
      setLoading(false);
      if (res) {
        console.log('reshere', res);
        setOtpData({
          ...otpData,
          ackMessage: OTP_VERIFY_SUCCESS,
          ackMessageType: ACK_SUCCESS,
        });
        toast.success(
          'User account is now verified. Please login with your credentials.'
        );
        setModalShow(false);
      }
    } catch (err: any) {
      setOtpData({
        value: '',
        ackMessage: OTP_VERIFY_FAILURE,
        ackMessageType: ACK_FAIL,
      });
      setLoading(false);
      toast.error(err.message);
    }
  };

  const onEmailOtpSuccess = async () => {
    try {
      setLoading(true);
      const res: any = await LoginService.verifyB2bUser(
        { code: otpData.value },
        token.idToken.jwtToken,
        token.accessToken.jwtToken
      );
      setLoading(false);
      if (res) {
        entSignIn(values);
      }
    } catch (err: any) {
      setLoading(false);
      console.log(err);
      toast.error(err.data.errors[0].title);
    }
  };

  return (
    <div>
      <ToastContainer />
      <PasswordUpdate
        show={passwordUpdateObj.display}
        cognitoUser={passwordUpdateObj.cognitoUser}
        userData={passwordUpdateObj.userAttr}
        onClose={handlePasswordUpdateClose}
      />
      <OtpPopup
        show={modalShow}
        isLoading={isLoading}
        handleClose={() => {
          resetOtpData();
          setModalShow(false);
        }}
        modalTitle={`Account Verification`}
        modalSubmitBtnText='Verify'
        onSubmit={() => (verifyEmail ? onEmailOtpSuccess() : onSuccess())}
        otpLabel={
          verifyEmail
            ? OTP_SENT_TO_EMAIL
            : key === 'b2c'
              ? format(OTP_SENT_TO_REG_MESSAGE, {
                suffixDigits: mobile?.slice(-4),
              })
              : OTP_SENT_TO_MOBILE
        }
        enableResendTimer={true}
        resendHandler={() => {
          resetOtpData();
          verifyEmail ? sendOtpThroughMail() : sendOtp();
        }}
        otpChangeHandler={(value) => {
          setOtpData({
            value: value,
            ackMessage: '',
            ackMessageType: 'success',
          });
        }}
        resendButtonText='Resend OTP'
        ackMessage={otpData.ackMessage}
        ackMessageType={otpData.ackMessageType}
        numInputs={6}
        otpValue={otpData.value}
        resendInterval={30}
      />

      <Modal
        show={isLoginError}
        onHide={() => setIsLoginError(false)}
        // backdrop='static'
        keyboard={false}
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        <Modal.Header>
          <div className='d-flex w-100 justify-content-between align-items-center'>
            {errorModal?.title && (
              <h4 className='text-center my-1'>{errorModal?.title}</h4>
            )}
            <CloseButton onClick={() => setIsLoginError(false)}></CloseButton>
          </div>
        </Modal.Header>
        <Modal.Body>
          {errorModal?.message && (
            <p className='h6 text-center mx-5 my-2'>{errorModal?.message}</p>
          )}
          <div className='text-center'>
            <Button
              className='w-50 mt-3'
              variant='primary'
              onClick={() => sendOtp()}
            >
              Get OTP
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <div className='login-wrapper' >
        <div className='login-banner d-none d-sm-block d-sm-flex'>
          <Carousel
            controls={false}
            indicators
            interval={4000}
            pause={false}
            className='login-banner-carousel'
          >
            <Carousel.Item>
              <img className='login-banner-slide' src={banner1} alt="eBullion banner" />
            </Carousel.Item>
            <Carousel.Item>
              <img className='login-banner-slide' src={banner2} alt="eBullion banner" />
            </Carousel.Item>
          </Carousel>
        </div>

        <div className='login-form mt-4'>
          <div className='login-form-group'>

            <div style={{ marginBottom: '8px' }}>
              <a
                href="https://www.ebullion.in/"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '14px',
                  color: '#99834D',
                  textDecoration: 'none',
                  cursor: 'pointer',
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#99834D"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ marginTop: '1px' }} // optional fine-tune
                >
                  <polyline points="15 18 9 12 15 6" />
                </svg>
                <span>Home</span>
              </a>
            </div>
            <div className='mt-0 my-5 d-sm-block d-md-none'>
              <a href="https://www.ebullion.in/" target="_blank" rel="noopener noreferrer">
                <img src={logo} alt="eBullion" style={{ cursor: 'pointer' }} />
              </a>
              <p style={{ fontSize: '14px', color: '#666', marginTop: '10px', marginBottom: '0' }}>
                Ready to invest in precious metals? Buy Gold and Silver online with eBullion
              </p>
            </div>
            <div className='title '>
              <h3>Sign In/Sign Up to your account</h3>
              <p className='d-none d-md-block'>
                Ready to invest in precious metals?
                Buy Gold and Silver online with eBullion
              </p>
            </div>
            <Tabs
              id='controlled-tab-example'
              activeKey={key}
              onSelect={(k) => {
                setKey(k);
                if (k == 'b2c') indFormRef.current.resetForm();
                else entFormRef.current.resetForm();

                sessionStorage.setItem('category', k);
              }}
              className='mb-3'
            >
              <Tab eventKey='b2c' title='Individual'>
                <>
                  <Formik
                    innerRef={indFormRef}
                    initialValues={{
                      isOtp: false,
                      isOtpSent: false,
                      username: '',
                      password: '',
                      otp: '',
                    }}
                    onSubmit={(
                      values,
                      {
                        setSubmitting,
                        resetForm,
                        setFieldTouched,
                        setFieldError,
                        setFieldValue,
                      }
                    ) => {
                      setSubmitting(false);
                      signIn(
                        values,
                        setFieldTouched,
                        setFieldError,
                        setFieldValue
                      );
                    }}
                    validationSchema={Yup.object().shape({
                      isOtp: Yup.boolean(),
                      isOtpSent: Yup.boolean(),
                      username: Yup.string()
                        .min(10, 'Invalid mobile number')
                        .max(10, 'Invalid mobile number')
                        .required('Invalid mobile number'),
                      password: Yup.string().when('isOtp', {
                        is: false,
                        then: Yup.string().required('Field is required'),
                        otherwise: Yup.string(),
                      }),
                      otp: Yup.string().when('isOtp', {
                        is: true,
                        then: Yup.string().when('isOtpSent', {
                          is: true,
                          then: Yup.string().required('Please enter OTP'),
                          otherwise: Yup.string(),
                        }),
                        otherwise: Yup.string(),
                      }),
                    })}
                  >
                    {({
                      isSubmitting,
                      values,
                      errors,
                      touched,
                      setFieldValue,
                      setFieldTouched,
                      setFieldError,
                      validateField,
                    }) => (
                      <Form translate={undefined}>
                        <div className='form-group mb-2'>
                          <label className='form-label'>Mobile</label>
                          <div className='input-group mb-3'>
                            <div className='input-group-text' id='basic-addon1'>
                              <select
                                className='form-control country-select'
                                onChange={(event) =>
                                  setCountryCode(event.target.value)
                                }
                                value={countryCode}
                              >
                                <option value={'+91'}>+91</option>
                              </select>
                            </div>
                            <Field
                              type='text'
                              placeholder=''
                              name='username'
                              className='form-control'
                              disabled={isOtpLogin && isOtpSent}
                              onChange={(e) => {
                                if (
                                  e.target.value.length > 10 ||
                                  /[^0-9]/.test(e.target.value)
                                )
                                  return;
                                setFieldValue('username', e.target.value);
                              }}
                            />
                          </div>
                          <div className='error'>
                            {errors.username && touched.username && (
                              <small id='my-helper-text'>
                                <img src={infoIco} alt='' />
                                {errors.username}
                              </small>
                            )}
                          </div>
                          <Field
                            type='text'
                            placeholder=''
                            name='isOtp'
                            className='form-control'
                            hidden
                          />
                        </div>

                        {isOtpLogin ? (
                          <>
                            <div className='form-group mb-2'>
                              <label className='form-label'>Password</label>
                              <div className='input-group mb-3'>
                                <Field
                                  type={isShowPwd ? 'text' : 'password'}
                                  placeholder='Password'
                                  name='password'
                                  style={{ position: 'unset' }}
                                  className='form-control'
                                />
                                <div
                                  className='input-group-text'
                                  id='basic-addon1'
                                  style={{
                                    border: '1px solid #ced4da',
                                    borderLeft: '0px',
                                    backgroundColor: 'white',
                                    borderRadius: '0rem 0.25rem 0.25rem 0rem',
                                  }}
                                >
                                  <a
                                    href='#'
                                    onClick={() => setShowPwd(!isShowPwd)}
                                  >
                                    <img
                                      className='m-2'
                                      style={{ width: '16px' }}
                                      src={isShowPwd ? hidden : eye}
                                      alt=''
                                    />
                                  </a>
                                </div>
                              </div>

                              <div className='error'>
                                {errors.password && touched.password && (
                                  <small id='my-helper-text'>
                                    <img src={infoIco} alt='' />
                                    {errors.password}
                                  </small>
                                )}
                              </div>
                            </div>

                            <div className='form-group mb-2 fp'>
                              <a
                                onClick={(e) => history.push('/reset-password')}
                                href='#'
                              >
                                Forgot Password ?
                              </a>
                            </div>
                          </>
                        ) : (
                          isOtpSent && (
                            <>
                              <OtpWithTimer
                                enableResendTimer
                                resendInterval={30}
                                numInputs={6}
                                otpLabel='Please enter OTP'
                                otpChangeHandler={(value) => {
                                  setOtpValue(value);
                                  setFieldValue('otp', value);
                                  if (value?.length === 6) {
                                    newVerifyOtp({
                                      ...values,
                                      otp: value,
                                    });
                                  }
                                }}
                                isCentered
                                otpValue={otpValue}
                                resendButtonText='Resend OTP'
                                ackMessage={
                                  showTerms
                                    ? 'OTP has been sent to your mobile number.'
                                    : 'OTP has been sent to your registered mobile number.'
                                }
                                ackMessageType='success'
                                resendHandler={() =>
                                  sendMobileOtp(values, setFieldValue)
                                }
                              ></OtpWithTimer>
                              <div className='text-end error'>
                                {errors.otp && touched.otp && (
                                  <small id='my-helper-text'>
                                    <img src={infoIco} alt='' />
                                    {errors.otp}
                                  </small>
                                )}
                              </div>
                            </>
                          )
                        )}

                        <div className='form-group mb-2'>
                          <label className='form-label d-flex align-items-center gap-2'>
                            <Field
                              type='checkbox'
                              placeholder=''
                              name='otp_checkbox'
                              checked={isOtpLogin}
                              onChange={(e) => {
                                setIsOtpLogin(e.target.checked);
                                setIsOtpSent(false);
                                setFieldValue('isOtpSent', false);
                                setFieldValue('isOtp', e.target.checked);
                              }}
                            />
                            Already have a password?
                          </label>
                        </div>

                        {isOtpLogin ? (
                          <Button
                            disabled={isLoading || !values.password || !values.username}
                            className='w-100 mt-3'
                            variant='primary'
                            type='submit'
                          >
                            {!isLoading ? (
                              'Sign in with Password'
                            ) : (
                              <div className='d-flex align-items-center justify-content-center gap-2'>
                                <div className='spinner-border spinner-border-sm text-white' role='status'>
                                  <span className='visually-hidden'>Loading...</span>
                                </div>
                                <span style={{ fontSize: '14px' }}>Signing you in...</span>
                              </div>
                            )}
                          </Button>
                        ) : !isOtpSent ? (
                          <Button
                            disabled={isLoading || !values.username || values.username.length !== 10}
                            className='w-100 mt-3'
                            variant='primary'
                            onClick={() => sendMobileOtp(values, setFieldValue)}
                          >
                            {!isLoading ? (
                              'Request OTP'
                            ) : (
                              <div className='d-flex align-items-center justify-content-center gap-2'>
                                <div className='spinner-border spinner-border-sm text-white' role='status'>
                                  <span className='visually-hidden'>Loading...</span>
                                </div>
                                <span style={{ fontSize: '14px' }}>Sending OTP...</span>
                              </div>
                            )}
                          </Button>
                        ) : (
                          <Button
                            disabled={isLoading || otpValue?.length !== 6}
                            className='w-100 mt-3'
                            variant='primary'
                            onClick={() => newVerifyOtp(values)}
                          >
                            {!isLoading ? (
                              'Verify OTP'
                            ) : (
                              <div className='d-flex align-items-center justify-content-center gap-2'>
                                <div className='spinner-border spinner-border-sm text-white' role='status'>
                                  <span className='visually-hidden'>Loading...</span>
                                </div>
                                <span style={{ fontSize: '14px' }}>Verifying OTP...</span>
                              </div>
                            )}
                          </Button>
                        )}

                        {!isOtpLogin && showTerms && (
                          <div className='text-center mt-2 mb-2'>
                            By Proceeding, you are agreeing to our{' '}
                            <a
                              href='https://ebullion.in/terms-and-conditions/terms.html'
                              target='_blank'
                              rel='noopener noreferrer'
                              style={{
                                fontSize: '14px',
                                textDecoration: 'underline',
                                color: "#99834D",
                              }}
                            >
                              Terms & Conditions
                            </a>
                          </div>
                        )}
                      </Form>
                    )}
                  </Formik>
                  <div className='text-center sign-in-text justify-content-between m-2'>
                    Need help?
                    <a
                      href='https://ebullion.in/contact-us'
                      style={{ fontSize: '14px', textDecoration: 'none' }}
                    >
                      {' '}
                      <span>Click Here</span>
                    </a>
                  </div>
                </>
              </Tab>
              <Tab eventKey='b2b' title='Enterprise'>
                <>
                  <Formik
                    innerRef={entFormRef}
                    initialValues={{
                      isOtp: false,
                      username: '',
                      password: '',
                    }}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                      setSubmitting(false);
                      entSignIn(values);
                    }}
                    validationSchema={Yup.object().shape({
                      isOtp: Yup.boolean(),
                      username: Yup.string()
                        .matches(
                          /^[A-Z0-9]+$/,
                          'Special characters are not allowed'
                        )
                        .trim('PAN is invalid')
                        .required('PAN is required'),
                      password: Yup.string().when('isOtp', {
                        is: false,
                        then: Yup.string().required('Field is required'),
                        otherwise: Yup.string(),
                      }),
                    })}
                  >
                    {({
                      isSubmitting,
                      values,
                      errors,
                      touched,
                      setFieldValue,
                      setFieldTouched,
                      setFieldError,
                      validateField,
                    }) => (
                      <Form translate={undefined}>
                        <div className='form-group mb-2'>
                          <label className='form-label'>
                            Permanent Account Number (PAN)
                          </label>
                          <div className='input-group mb-3'>
                            <Field
                              type='text'
                              placeholder=''
                              name='username'
                              className='form-control'
                              disabled={isOtpLogin && isOtpSent}
                              onChange={(e) => {
                                if (
                                  e.target.value.length > 10 ||
                                  !/^[a-zA-Z0-9]*$/.test(e.target.value)
                                )
                                  return;
                                setFieldValue(
                                  'username',
                                  e.target.value?.toUpperCase()
                                );
                                setPan(e.target.value?.toUpperCase());
                              }}
                            />
                          </div>
                          <div className='error'>
                            {errors.username && touched.username && (
                              <small id='my-helper-text'>
                                <img src={infoIco} alt='' />
                                {errors.username}
                              </small>
                            )}
                          </div>
                          <Field
                            type='text'
                            placeholder=''
                            name='isOtp'
                            className='form-control'
                            hidden
                          />
                        </div>

                        <>
                          <div className='form-group mb-2'>
                            <label className='form-label'>Password</label>
                            <div className='input-group mb-3'>
                              <Field
                                type={isShowPwd ? 'text' : 'password'}
                                placeholder='Password'
                                name='password'
                                style={{
                                  position: 'unset',
                                  borderRight: '0px',
                                  borderRadius: '0.25rem 0rem 0rem 0.25rem',
                                  boxShadow: 'none',
                                  zIndex: 0,
                                }}
                                className='form-control'
                              />
                              <div
                                className='input-group-text'
                                id='basic-addon1'
                                style={{
                                  border: '1px solid #ced4da',
                                  borderLeft: '0px',
                                  backgroundColor: 'white',
                                  borderRadius: '0rem 0.25rem 0.25rem 0rem',
                                  padding: '0',
                                  zIndex: 0,
                                }}
                              >
                                <a
                                  href='#'
                                  onClick={() => setShowPwd(!isShowPwd)}
                                >
                                  <img
                                    className='m-2'
                                    style={{ width: '16px' }}
                                    src={isShowPwd ? hidden : eye}
                                    alt=''
                                  />
                                </a>
                              </div>
                            </div>

                            <div className='error'>
                              {errors.password && touched.password && (
                                <small id='my-helper-text'>
                                  <img src={infoIco} alt='' />
                                  {errors.password}
                                </small>
                              )}
                            </div>
                          </div>

                          <div className='form-group mb-2 fp'>
                            <a
                              onClick={(e) => history.push('/ent-reset-password')}
                              href='#'
                            >
                              Forgot Password ?
                            </a>
                          </div>
                        </>

                        <Button
                          disabled={isLoading || !values.username || !values.password}
                          className='w-100 mt-3'
                          variant='primary'
                          type='submit'
                        >
                          {!isLoading ? (
                            'Sign in'
                          ) : (
                            <div className='d-flex align-items-center justify-content-center gap-2'>
                              <div className='spinner-border spinner-border-sm text-white' role='status'>
                                <span className='visually-hidden'>Loading...</span>
                              </div>
                              <span style={{ fontSize: '14px' }}>Signing you in...</span>
                            </div>
                          )}
                        </Button>
                      </Form>
                    )}
                  </Formik>
                  <div className='text-center sign-in-text justify-content-between'>
                    <a onClick={(e) => history.push('/enterprise')}>
                      Own a business ? <span>Open enterprise account</span>{' '}
                    </a>
                    <br></br>
                    Need help?
                    <a
                      href='https://ebullion.in/contact-us'
                      style={{ fontSize: '14px', textDecoration: 'none' }}
                    >
                      {' '}
                      <span>Click Here</span>
                    </a>
                  </div>
                </>
              </Tab>
            </Tabs>

            {/* ── App Download Buttons ── */}
            <div style={{ textAlign: 'center' }}>
              <div style={{ marginTop: '16px' }}>
                <span style={{ fontSize: '14px', color: '#666' }}>
                  Download the app & manage everything on the go
                </span>
              </div>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '12px',
                  marginTop: '12px',
                  paddingBottom: '16px',
                  flexWrap: 'wrap',
                }}
              >
                {/* iOS – App Store */}
                <a
                  href="https://apps.apple.com/in/app/ebullion/id1619968412"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: 'inline-flex', textDecoration: 'none' }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      backgroundColor: '#000000',
                      color: '#ffffff',
                      borderRadius: '8px',
                      padding: '8px 14px',
                      minWidth: '140px',
                      cursor: 'pointer',
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 814 1000"
                      fill="white"
                    >
                      <path d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76 0-103.7 40.8-165.9 40.8s-105-37.3-146.8-93.3c-47.8-65-87.6-166.3-87.6-262.2 0-233.2 155.2-357.2 307.4-357.2 78.5 0 144 51.8 193 51.8 46.6 0 120.5-54.9 191.1-54.9zm-134.3-68c-28.6 32.8-77 57.3-126.8 57.3-6.4 0-12.8-.5-19.2-1.9 1.9-40.8 19.2-83.6 46.6-112.8 28.6-30.7 77-55.3 121.1-57.3 1.3 4.5 1.9 9 1.9 14.5 0 38.9-15.3 80.5-23.6 100.2z" />
                    </svg>
                    <div style={{ lineHeight: 1.2 }}>
                      <div style={{ fontSize: '10px', opacity: 0.8 }}>
                        Download on the
                      </div>
                      <div style={{ fontSize: '15px', fontWeight: 600 }}>
                        App Store
                      </div>
                    </div>
                  </div>
                </a>

                {/* Android – Play Store */}
                <a
                  href="https://play.google.com/store/apps/details?id=in.ebullion.app"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: 'inline-flex', textDecoration: 'none' }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      backgroundColor: '#000000',
                      color: '#ffffff',
                      borderRadius: '8px',
                      padding: '8px 14px',
                      minWidth: '140px',
                      cursor: 'pointer',
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 512 512"
                    >
                      <linearGradient id="ps-a" x1="61.8" y1="3.16" x2="236.37" y2="177.73">
                        <stop offset="0" stopColor="#00a0ff" />
                        <stop offset="1" stopColor="#00beff" />
                      </linearGradient>
                      <linearGradient id="ps-b" x1="21.8" y1="256" x2="293.49" y2="256">
                        <stop offset="0" stopColor="#ffda00" />
                        <stop offset=".41" stopColor="#ffbd00" />
                        <stop offset="1" stopColor="#ffa500" />
                      </linearGradient>
                      <linearGradient id="ps-c" x1="142.29" y1="295.32" x2="320.77" y2="473.8">
                        <stop offset="0" stopColor="#ff3a44" />
                        <stop offset="1" stopColor="#c31162" />
                      </linearGradient>
                      <linearGradient id="ps-d" x1="-.19" y1="38.52" x2="80.84" y2="119.55">
                        <stop offset="0" stopColor="#32a071" />
                        <stop offset=".48" stopColor="#15cf74" />
                        <stop offset="1" stopColor="#00f076" />
                      </linearGradient>
                      <path d="M27.75 9.28A20.27 20.27 0 0 0 21.8 24.6v462.8a20.27 20.27 0 0 0 5.95 15.32L295 256v-6.44L28.58 8.48z" fill="url(#ps-a)" />
                      <path d="M384.19 345.23L295 256v-6.44l89.21-88.82 105.73 60.08c30.2 17.16 30.2 45.22 0 62.39l-105.73 60.08z" fill="url(#ps-b)" />
                      <path d="M386.22 344.09L295 252.78 27.75 520a23.53 23.53 0 0 0 30.09.9l328.38-176.81" fill="url(#ps-c)" />
                      <path d="M386.22 167.91L57.84 -8.9A23.53 23.53 0 0 0 27.75-8L295 259.22z" fill="url(#ps-d)" />
                    </svg>
                    <div style={{ lineHeight: 1.2 }}>
                      <div style={{ fontSize: '10px', opacity: 0.8 }}>
                        Get it on
                      </div>
                      <div style={{ fontSize: '15px', fontWeight: 600 }}>
                        Google Play
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div style={{ textAlign: 'center', marginTop: '12px' }}>
              <a
                href="https://www.ebullion.in/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '8px 14px',
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#99834D',
                  textDecoration: 'none',
                  border: '1px solid rgba(153, 131, 77, 0.4)',
                  borderRadius: '8px',
                  background: 'rgba(153, 131, 77, 0.05)',
                  backdropFilter: 'blur(6px)',
                  transition: 'all 0.25s ease',
                  position: 'relative',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.border = '1px solid #99834D';
                  e.currentTarget.style.boxShadow =
                    '0 6px 18px rgba(153, 131, 77, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.border = '1px solid rgba(153, 131, 77, 0.4)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <span>    Explore more about eBullion
                </span>

                <span
                  style={{
                    fontSize: '16px',
                    transition: 'transform 0.25s ease',
                  }}
                  className="cta-arrow"
                >
                  →
                </span>
              </a>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;